import React from 'react';

const MoveButton = ({ onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`
      w-full py-3 sm:py-2.5 px-4 rounded-xl border-2 border-neutral-900
      text-sm font-medium transition-colors
      ${disabled
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-400'
        : 'bg-yellow-500 text-neutral-900 hover:bg-yellow-600 active:bg-yellow-700'
      }
    `}
    aria-label="Move to selected basket"
  >
    Move to Selected Basket
  </button>
);

export default MoveButton;
